import { adalApiFetch } from "../../../authProvider";
import { endPoints, API_ROOT, API_ROOT_V2 } from "../../../appSettings";

export const GET_USER = "GET_USER";

export const GET_USERS = "GET_USERS";
export const ADD_USER = "ADD_USER";
export const EDIT_USER = "EDIT_USER";
export const DELETE_USER = "DELETE_USER";

export const GetUser = (userId) => (dispatch) => {
  adalApiFetch(
    fetch,
    `${API_ROOT}${endPoints.user}/${userId}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    },
    dispatch
  )
    .then((res) => {
      if (res.status === 404) {
        return dispatch({
          type: GET_USER,
          payload: undefined,
          userStatus: res.status,
        });
      }
      return res.json().then((json) => {
        return dispatch({
          type: GET_USER,
          payload: json,
          userStatus: undefined,
        });
      });
    })
    .catch((error) => {
      throw Error(error);
    });
};

export const getUsersV2 = () => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.user}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    )
      .then((response) =>
        response.json().then((json) => {
          if (!response.ok) {
            return Promise.reject(json);
          }
          dispatch({ type: GET_USERS, payload: json });
        })
      )
      .catch((error) => {
        throw Error(error);
      });
  };
};

export function addUser(user) {
  const url = `${API_ROOT}${endPoints.user}`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: ADD_USER,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: ADD_USER,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export function editUser(id, permissions) {
  const url = `${API_ROOT}${endPoints.user}/${id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(permissions),
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: EDIT_USER,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: EDIT_USER,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export function deleteUserV2(email) {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.user}/${email}`,
      {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response) => response);
  };
}

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.user}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};
